var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "fav",
  "use": "fav-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fav\"><path d=\"M18.666 9.307c1.78-1.712 1.78-4.47 0-6.183-1.556-1.498-4.096-1.498-5.652 0L11 5.065l-.694-.67-1.32-1.27c-1.556-1.498-4.095-1.498-5.652 0-1.78 1.713-1.78 4.472-.013 6.17L11 16.44l7.666-7.13zm-7.04-7.624c2.33-2.244 6.097-2.244 8.427 0 2.596 2.5 2.596 6.566-.012 9.077L11 19.17l-.682-.634-8.37-7.787a6.25 6.25 0 0 1 0-9.067c2.33-2.244 6.095-2.244 8.427 0l.625.603.627-.603z\" fill=\"#3A3A3A\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol